export default {"src":"/_next/static/media/Dandruff and Scalp Psoriasis.ef64856f.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};